import React from "react";
import StarBorderOutlinedIcon from "@mui/icons-material/StarBorderOutlined";
import { ModelElementType } from "@/components/entities";
import { SectionRule } from "components/common/SectionRule";
import {
  ListBox,
  OVERVIEW_LIST_ROWS,
} from "@/components/main/pages/pageColumn";
import { ModelRows } from "./ModelRows";
import { PINNED_LIMIT } from "./selectors";

interface PinnedColumnProps {
  /** The rows to show: the first PINNED_LIMIT, or every pin once expanded. */
  models: ModelElementType[];
  total: number;
  expanded: boolean;
  onToggle: () => void;
  testId?: string;
}

export const PinnedColumn: React.FC<PinnedColumnProps> = ({
  models,
  total,
  expanded,
  onToggle,
  testId,
}) => (
  <>
    <SectionRule
      inset
      icon={<StarBorderOutlinedIcon sx={{ fontSize: 14 }} />}
      label={expanded ? `All pinned · ${total}` : "Pinned"}
      action={
        total > PINNED_LIMIT
          ? {
              label: expanded ? "Show less" : `Show all · ${total}`,
              onClick: onToggle,
              testId: "toggle-all-pinned",
            }
          : undefined
      }
    />
    <ListBox rows={OVERVIEW_LIST_ROWS} data-overview-list data-testid={testId}>
      <ModelRows models={models} byPin movable />
    </ListBox>
  </>
);
